import React, { useEffect, useState } from 'react'
import "./AllSolution.css"
import { useTranslation } from 'react-i18next'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import AllSolutionsHero from '../../components/pages/AllSolutions/AllSolutionsHero/AllSolutionsHero'
import ConstNeed from '../../components/pages/AllSolutions/ConstNeed/ConstNeed'
import AllSolProducts from '../../components/pages/AllSolutions/AllSolProducts/AllSolProducts'
import Downloads from '../../components/pages/AllSolutions/Downloads/Downloads'
import AllSolutionsRequestNewProject from '../../components/pages/AllSolutions/AllSolutionsRequestNewProject/AllSolutionsRequestNewProject'
import { getPageContent } from '../../api/content'

const unwrapSectionData = (section) => {
    if (section == null) return section
    if (typeof section === "string") {
        const t = section.trim()
        if (t.startsWith("{")) {
            try {
                const parsed = JSON.parse(t)
                if (parsed && typeof parsed === "object") return unwrapSectionData(parsed)
            } catch {
                return section
            }
        }
        return section
    }
    if (typeof section !== "object") return section
    if (section.data && typeof section.data === "object") return section.data
    return section
}

const normalizeSectionSlug = (key) =>
    String(key || "")
        .toLowerCase()
        .replace(/[_\s-]+/g, "")

const findPageSection = (root, slug) => {
    if (!root || typeof root !== "object") return undefined
    const target = normalizeSectionSlug(slug)
    const hit = Object.keys(root).find((k) => normalizeSectionSlug(k) === target)
    return hit != null ? root[hit] : undefined
}

const AllSolution = () => {
    const { i18n } = useTranslation()
    const [pageContent, setPageContent] = useState({})

    useEffect(() => {
        let isMounted = true
        const load = async () => {
            const language = (i18n.language || "en").toLowerCase()
            const pageAliases = ["allsolutions", "all-solution", "allsolution", "solutions"]
            for (const page of pageAliases) {
                try {
                    const data = await getPageContent({ page, language })
                    if (data && typeof data === "object" && Object.keys(data).length) {
                        if (isMounted) setPageContent(data)
                        return
                    }
                } catch {
                    // try next alias
                }
            }
            if (isMounted) setPageContent({})
        }
        load()
        return () => {
            isMounted = false
        }
    }, [i18n.language])

    const heroSection =
        findPageSection(pageContent, "hero") ||
        findPageSection(pageContent, "allsolutionshero") ||
        findPageSection(pageContent, "allsolutions")

    return (
        <div className='allsolution'>
            <Navbar />
                <AllSolutionsHero content={unwrapSectionData(heroSection)} />

            <div className="allsolution-content-guide">
                <ConstNeed />
                <AllSolProducts />
                <Downloads />
                <AllSolutionsRequestNewProject />
            </div>
            <Footer />
        </div>
    )
}

export default AllSolution